var map = {
	"./en-US": "b1cf",
	"./en-US.js": "b1cf",
	"./zh-CN": "df04",
	"./zh-CN.js": "df04",
	"./zh-TW": "2547",
	"./zh-TW.js": "2547"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8501";